export const useRaces = () => {
  const races = [
    { value: 1, name: "Aboriginal or Torres Strait Islander Australian" },
    { value: 2, name: "American Indian or Alaska Native" },
    { value: 3, name: "Asian" },
    { value: 4, name: "Black or African American" },
    { value: 5, name: "Canadian Aboriginal/Indigenous" },
    { value: 6, name: "Caucasian/White" },
    { value: 7, name: "Hispanic/Latino" },
    { value: 8, name: "Native Hawaiian or Other Pacific Islander" },
    { value: 10, name: "Puerto Rican" },
  ]

  return { races }
}
